import React, { useState } from 'react'
import { settings } from '../../resources'
import getText from '../strings'
import { ImagePreview, LinkWithIcon } from '../../application'
import * as validator from '../../application/validator'
import WizardButtons from './WizardButtons'
import styled from 'react-emotion'

const List = styled('ol')`
 li {
  padding: 5px 10px;
 }
`

const Wrapper = styled('div')`
  text-align: center;
  margin: 20px 0;
  label {
    cursor: pointer;
  }
`

const FileInput = ({ accept, title, name, onChange }) => {
  const [file, setFile] = useState(null)

  const handleChange = file => {
    onChange(file)
    setFile(file)
  }

  return (
    <Wrapper>
      {<ImagePreview file={file} />}
      {file && <div>{file.name}</div>}
      <label htmlFor={name}>
        <LinkWithIcon icon="plus--circled" text={title} />
      </label>
      <input
        id={name}
        name={name}
        style={{ display: 'none' }}
        type="file"
        accept={accept}
        onChange={({ target: { validity, files: [file] } }) =>
          validity.valid && handleChange(file)} />
    </Wrapper>
  )
}

const MAX_FILE_SIZE_IN_MB = 20
const fileSize = validator.fileSize(MAX_FILE_SIZE_IN_MB)

export default ({ onBackClick, onNextClick, errors, caseType }) => {
  const [file, setFile] = useState(null)

  const handleChange = (file) => {
    setFile(file)
  }

  const invalid = file === null

  return (
    <div>
      <List>
        <li><a href={settings.gdprConsent[caseType]} rel="noopener noreferrer" target="_blank">{getText('wizard', 'step2', 'downloadform')}</a>{getText('wizard', 'step2', 'fillform')}</li>
        <li>{getText('wizard', 'step2', 'scan')}</li>
        <li>{getText('wizard', 'step2', 'upload')}</li>
      </List>
      <FileInput onChange={handleChange} validate={[validator.required, fileSize]} accept=".pdf,image/*" name="idFile" title={getText('wizard', 'step2', 'upload')} />
      {errors}
      <WizardButtons>
        <button onClick={onBackClick} className="btn ghost-blue" type="button">{getText('wizard', 'step2', 'back')}</button>
        <button
          className="btn btn-function"
          type="button"
          disabled={invalid}
          onClick={() => onNextClick(file)}>
          {getText('wizard', 'step2', 'next')}
        </button>
      </WizardButtons>
    </div>
  )
}